// extracted by mini-css-extract-plugin
export default {"recos":"T6-z","productCardOverride":"U6-z","rowHasBadge":"V6-z"};